import { useCallback, useMemo } from "react";
import { useFlags as useLDFlags } from "launchdarkly-react-client-sdk-original";
import { useLocalStorage } from "@rehooks/local-storage";

const DEFAULT_FLAGS = {};

export function useModifiedFlags() {
  const [flags, setFlags, clearFlags] = useLocalStorage("devtools-flags", DEFAULT_FLAGS);

  const modifyFlag = useCallback(
    (key: string, value: boolean) => setFlags({ ...flags, [key]: value }),
    [flags, setFlags]
  );

  return [flags, modifyFlag, clearFlags] as const;
}

export function useFlags() {
  const ldFlags = useLDFlags();
  const [lsFlags] = useModifiedFlags();

  const flags = useMemo(
    () => ({
      ...ldFlags,
      ...lsFlags,
    }),
    [ldFlags, lsFlags]
  );

  return flags;
}
